export default {
  title: '3D Модели',
  heading: 'Ошибка 404',
  error1: 'Страница не найдена',
  error2: 'Пожалуйста, проверьте адрес или вернитесь ',
  error3: ' на домашнюю страницу',
  description: 'У вас есть возможность увидеть товар в виде 3D модели!',
}